export default __webpack_public_path__ + "static/media/logo-icon.d95addd5.png";